import getSelectableObjects from './getSelectableObjects';
import { extractSeatsFromSelection } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/extractSeatsFromSelection';

function getSelectableSeats(session, selection) {
    return extractSeatsFromSelection(getSelectableObjects(session, selection));
}

export default getSelectableSeats;
